import { GymEnvironment } from './gym';

export type NameForLogger = 'production' | 'staging' | 'development' | 'tests';

export interface IEnvironmentDetails {
  environmentName: string;
  nameForLogging: NameForLogger;
  gymEnvironment: GymEnvironment;
  isProduction: boolean;
}

export function getEnvironmentDetailsFromName(
  name: string | undefined,
  nodeEnv?: string | undefined,
): IEnvironmentDetails {
  if (!name && nodeEnv === 'test') {
    return getEnvironmentDetailsFromName('tests');
  }

  const environmentName = name || 'development';
  const isProduction = environmentName === 'prod';

  function getNameForLogging(): NameForLogger {
    if (isProduction) {
      return 'production';
    }
    if (environmentName === 'coggy') {
      return 'staging';
    }
    if (environmentName === 'test' || environmentName === 'tests') {
      return 'tests';
    }
    return 'development';
  }

  return {
    environmentName,
    nameForLogging: getNameForLogging(),
    isProduction,
    gymEnvironment: isProduction ? GymEnvironment.Production : GymEnvironment.Staging,
  };
}
